import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, AfterViewInit, ElementRef, NgZone } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';

import { PgRecorder } from '../../common/audio-recording/pg-recorder';
import { MyModal } from './../../common/my-modal/my-modal.component';
import { LoggerService } from './../../../services/logger.service';
import { ConfigHelper } from '../../../services/config.helper';
import * as ErrorMessages from '../../../errors/constants';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'microphone-check',
    template: require('./microphone-check.component.html')
})
export class MicrophoneCheckComponent implements OnInit, OnDestroy, AfterViewInit {
    @Output() microphoneCheckCompleted: EventEmitter<any> = new EventEmitter<any>();

    step: number = 1;
    recordingTime: number;
    currentProgress: number;
    infoBoxVisible: boolean;
    infoBoxText: string;
    infoBoxMode: string;
    iconCssClass: string;
    counterText: string;
    inputActivityLevel: number;
    playbackSubscription: Subscription;
    recordingSubscription: Subscription;
    inputActivitySubscription: Subscription;
    recorder: PgRecorder;
    silentClipAudio: HTMLAudioElement;
    isWebDelivery: boolean;

    constructor(
        private elementRef: ElementRef,
        private myModal: MyModal,
        private loggerService: LoggerService,
        private ngZone: NgZone
    ) {
        this.isWebDelivery = ConfigHelper.isTdpMode(true);
    }

    ngOnInit() {
        this.recordingTime = 25;
    }

    ngOnDestroy() {
        if (this.recordingSubscription) {
            this.recordingSubscription.unsubscribe();
        }

        if (this.playbackSubscription) {
            this.playbackSubscription.unsubscribe();
        }

        if (this.inputActivitySubscription) {
            this.inputActivitySubscription.unsubscribe();
        }
    }

    ngAfterViewInit() {
        this.silentClipAudio = this.createAudioElement("silent_clip.mp3");
    }

    createAudioElement(src: string) {
        const elem = (this.elementRef.nativeElement as HTMLElement);
        const audioElem = document.createElement("audio");
        audioElem.autoplay = false;
        audioElem.controls = false;
        audioElem.autoplay = false;
        audioElem.src = `${ConfigHelper.getAudioAssetUrl()}/${src}`;
        elem.appendChild(audioElem);
        return audioElem;
    }

    startRecording() {
        this.silentClipAudio.play();
        PgRecorder.create(this.loggerService)
            .then(recorder => {
                this.recorder = recorder;
                this.step = 2;
                this.currentProgress = 0;
                this.recorder.start(this.playRecording);
                this.infoBoxVisible = true;
                this.infoBoxText = "Recording...";
                this.infoBoxMode = "ProgressBar";
                this.iconCssClass = 'rec-icon';
                this.recordingSubscription = Observable.interval(1000)
                    .take(this.recordingTime)
                    .subscribe(x => {
                        const timeElapsed = x + 1;
                        this.currentProgress = this.setProgress(timeElapsed, this.recordingTime);
                        if (timeElapsed >= this.recordingTime) {
                            this.stopRecording();
                        }
                    });

                this.inputActivitySubscription = Observable.interval(200)
                    .subscribe(x => {
                        this.inputActivityLevel = 100 - this.recorder.getInputActivityLevel();
                    });
            })
            .catch(error => {
                const retry = "Retry";
                const cancel = "Cancel";
                let options = [{ label: retry, style: "btn-primary" }];
                if (ConfigHelper.canSkipMicrophoneCheck()) {
                    options.push({ label: cancel, style: "btn-secondary" });
                }

                this.myModal.showRegularDlg(
                    "Error",
                    ConfigHelper.isTdpMode() ? ErrorMessages.Microphone_Check_With_Code : ErrorMessages.Microphone_Check,
                    options)
                    .then(x => {
                        switch(x) {
                            case cancel:
                                break;
                            case retry:
                                this.startRecording();
                                break;
                        }
                    });
            });
    }

    stopRecording() {
        if (this.recordingSubscription) {
            this.recordingSubscription.unsubscribe();
        }

        if (this.inputActivitySubscription) {
            this.inputActivitySubscription.unsubscribe();
        }

        this.inputActivityLevel = 100;
        this.recorder.stop();
    }

    playRecording = () => {
        this.ngZone.run(() => {
            this.step = 3;

            this.currentProgress = 0;
            this.infoBoxVisible = true;
            this.infoBoxText = "Playing...";
            this.infoBoxMode = "ProgressBar";
            this.iconCssClass = 'play-icon';

            this.playbackSubscription = Observable.interval(1000)
                .take(this.recordingTime + 1)
                .subscribe(x => {
                    const timeElapsed = x + 1;
                    this.currentProgress = this.setProgress(timeElapsed, this.recordingTime);
                }, null, () => {
                    this.step = 4;
                    this.infoBoxVisible = false;
                });

            const audio = document.getElementById('audio-player');
            this.recorder.play(audio);
        });
    }

    setProgress(current: number, totalTime: number): number {
        return (current / totalTime) * 100;
    }

    badRecording() {
        this.ngZone.run(() => {
            this.step = 5;
        });
    }

    goodRecording() {
        this.microphoneCheckCompleted.emit("done");
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/microphone-check/microphone-check.component.ts